<template>
  <div>
    <v-autocomplete
        v-model="customer"
        :items="searchResults"
        :loading="isLoading"
        :search-input.sync="search"
        hide-no-data
        hide-selected
        item-text="desc"
        item-value="_id"
        :label="$t('customer')"
        :placeholder="$t('startTypingToSearch')"
        return-object
        @change="setResult"
        chips
        small-chips
        deletable-chips
        :hint="(searchResults.length === 0 && showHint) ? $t('noResults') : ''"
        outlined
        dense
        hide-details
    />
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

export default {
  name: 'CustomerAutocomplete',
  props: {
    initValue: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    customer: null,
    search: '',
    searchResults: [],
    isLoading: false,
    showHint: false
  }),
  watch: {
    search(val) {
      if (!val || val.length <= 2 || this.isLoading) return;

      this.isLoading = true;
      this.showHint = false;

      setTimeout(() => {
        this.searchResults = [];

        if(this.getUser.super_admin){
          this.searchCustomer({ search: this.search }).then(result => {
            if (result.length > 0) {
              this.searchResults = result.map(x => ({
                desc: `${x.name} ${x.surname} - ${x.email} - ${x.phone}`,
                _id: x._id
              }));
            }

            this.showHint = true;
            this.isLoading = false;
          });
        }else {
          this.searchMyUsers({ search: this.search, center_id: this.getUser.center_id }).then(result => {
            if (result.length > 0) {
              this.searchResults = result.map(x => ({
                desc: `${x.name} ${x.surname} - ${x.email} - ${x.phone}`,
                _id: x._id
              }));
            }

            this.showHint = true;
            this.isLoading = false;
          });
        }

      }, 1500);
    },
    initValue(newVal) {
      if (newVal) this.fetchCustomerById(newVal);
    }
  },
  created() {
    if (this.initValue) {
      this.fetchCustomerById(this.initValue);
    }
  },
  methods: {
    ...mapActions({
      searchCustomer: 'customers/search',
      searchMyUsers: 'customers/searchMyUsers',
    }),
    setResult() {
      if (this.customer && this.customer._id) {
        this.$emit('message', this.customer._id);
      } else {
        this.searchResults = [];
        this.$emit('message', '');
      }
    },
    async fetchCustomerById(user_id) {
      const result = await this.searchCustomer({ search: user_id });
      if (result && result.length > 0) {
        const user = result[0];
        const customerObj = {
          desc: `${user.name} ${user.surname} - ${user.email} - ${user.phone}`,
          _id: user._id
        };
        this.customer = customerObj;
        this.searchResults = [customerObj];
      }
    }
  },
  computed: {
    ...mapGetters({
      'getUser':'user/getUser'
    }),
  },
};
</script>

<style scoped></style>
